<template>
	<main class="main">
		<div class="main__page">
			<div class="card__header">
				<h2 class="main-title">
					<button class="btn light" type="button" @click="go('new')"
							:disabled="customers.loading"><span>{{ $t('common.add') }}</span>
					</button>
				</h2>
				<form class="form search customer-search" @submit.prevent="submitSearch">
					<div class="form__field">
						<input type="text" class="form__field-input" v-model.trim="searchText"/>
					</div>
					<button type="submit" class="search__btn" :disabled="customers.loading">
                        <span v-if="customers.loading" class="loading">
                            <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        </span>
						<span v-if="!customers.loading" class="start-search">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23"><path
									d="M23.008 21.952l-1.047 1.047-7.356-7.357c-3.492 2.958-8.723 2.796-12.016-.497A8.886 8.886 0 0115.154 2.579c3.294 3.293 3.455 8.525.498 12.016l7.356 7.357zM14.107 3.626A7.405 7.405 0 103.636 14.099 7.405 7.405 0 0014.107 3.626z"/></svg>
                        </span>
					</button>
					<span class="reset">
                            <button type="button" class="btn light" v-if="isFiltered" @click="clearSearch()"
									:disabled="customers.loading">Reset</button>
                        </span>
				</form>
			</div>
			<div v-if="selected && selected.length > 0" style="line-height: 90px">
				Hai selezionato {{ selected.length }} elementi.
				<button class="btn merge btn-gray" @click="select_all()">Seleziona tutto</button>
				<button class="btn merge btn-gray" @click="deselect_all()">Deseleziona tutto</button>
				<button class="btn merge" @click="showMergeModal = true" v-if="selected.length > 1">Unisci selezionati</button>
			</div>
			<div class="card">
				<div class="card__detail">
					<div class="list__item" v-for="customer in this.customers.data" v-bind:key="customer.id">
                        <span class="col">
                                <label class="my_checkbox">
                                    <input type="checkbox" v-model="customer.selected" :value="customer.id" number>
                                    <span v-bind:class="{'selected': customer.selected }">&nbsp;</span>

                                    <strong>{{ customer.agency }}</strong>
                                        {{ customer.address }}
                                </label>
                        </span>
						<span class="col">
                            <button class="btn light" type="button" @click="go(customer.id)"
									:disabled="customers.loading"><span>{{ $t('common.edit') }}</span>
                            </button>
                        </span>
					</div>
					<Pagination v-model="customers"></Pagination>
				</div>
			</div>
		</div>
		<customer-merge-form @close="showMergeModal = false" :customers="selected" v-model="showMergeModal" @success="init()"></customer-merge-form>
	</main>
</template>
<script>
    import Pagination from "../../components/Pagination";
    import CustomerMergeForm from "./CustomerMergeModal";

    export default {
        name: 'customers',
        components: {CustomerMergeForm, Pagination},
        mounted() {
            this.init();
        },
        data() {
            return {
                'customers': this.api.customers,
                'isFiltered': false,
                'searchText': null,
                'selected': [],
				'showMergeModal': false
            }
        },
        methods: {
            init() {
                this.isFiltered = false;
                this.searchText = null;
                this.selected = [];
                this.showMergeModal = false;
                this.customers = this.api.customers;
                this.customers.getList();
            },
            submitSearch() {
                this.searchText = this.searchText.trim();
                this.deselect_all();
                this.isFiltered = false;
                this.customers.getList(this.searchText);
                if (this.searchText != "") {
                    this.isFiltered = true;
                }
            },
            clearSearch() {
                this.searchText = "";
                this.deselect_all();
                this.customers.getList(this.searchText);
                this.isFiltered = false;
            },
            go(id) {
                this.$router.push(`/customers/${id}`);
            },
            check_select() {
                this.selected = [];
                this.customers.data.map(c => {
                    if (c && c.selected && c.selected == true) {
                        this.selected.push(c);
                    }
                });
            },
            select_all() {
                this.selected = [];
                this.customers.data.map((c, index) => {
                    this.customers.data[index].selected = true;
                    this.selected.push(c);
                });
                this.check_select();
            },
            deselect_all() {
                this.selected = [];
                this.customers.data.map((c, index) => {
                    this.customers.data[index].selected = false;
                });
                this.check_select();
            }
        },
        watch: {
            'customers.data': {
                handler: function (val, oldVal) {
                    this.check_select();
                },
                deep: true
            }
        }
    }
</script>
<style lang="scss">
	@import './src/scss/variables';

	.merge {
		margin-right: 10px;
	}

	.btn-gray {
		background: white;
		border: 1px solid $middle-green;
		color: $middle-green;
	}


	.card {
		&__header {
			display: flex;
			justify-content: space-between;
			background: transparent;
			height: auto;
			padding: 30px 0;

			.customer-search {
				width: 90%;
			}

			.card__header-link {
				display: flex;
				align-items: center;
				justify-content: flex-end;
				background: $middle-green;
				padding: 10px 20px;
				transition: 300ms $ease-out-quint;

				.btn {

					&-icon .bar,
					&-label {
						transition: 300ms $ease-out-quint;
					}

					&-icon {
						display: block;
						width: 20px;
						height: 20px;
						margin-right: 15px;
						position: relative;

						.bar {
							position: absolute;
							top: 50%;
							left: 50%;
							background: $white;
							width: 15px;
							height: 4px;
							transform: translate(-50%, -50%);

							&:last-of-type {
								transform: translate(-50%, -50%) rotate(90deg);
							}
						}
					}

					&-label {
						display: block;
						font-weight: 700;
						font-size: 0.8em;
						color: $white;
						text-transform: uppercase;
					}
				}

				&:hover {
					background: $white;

					.btn {
						&-icon .bar {
							background: $middle-green;
						}

						&-label {
							color: $middle-green;
						}
					}
				}
			}
		}
	}

	.my_checkbox {
		cursor: pointer;

		input {
			display: none;
		}

		span {
			float: left;
			width: 20px;
			height: 35px;
			display: block;
			background: $light-gray;
			margin-right: 10px;
		}

		span.selected {
			background: $middle-green;
		}

	}

	.customers__list {
		display: flex;
		flex-direction: column;

		.customer {
			padding: 15px 10px;
			position: relative;

			&:before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				background: $middle-green;
				width: 100%;
				height: 100%;
				z-index: 1;
				transform: scaleY(0);
				transform-origin: center bottom;
				transition: 600ms $ease-out-quint;
			}

			&__agency,
			&__referent {
				position: relative;
				z-index: 2;
				transition: 600ms $ease-out-quint;
			}

			&__agency {
				display: block;
				width: 100%;
				font-size: 1.5em;
				font-weight: 300;
				padding-bottom: 7px;
			}

			&__referent {
				font-size: 0.7em;
				text-transform: uppercase;
				color: $gray;

				strong {
					font-weight: 700;
				}
			}

			&:nth-of-type(even) {
				background: rgba($gray, 0.05);
			}

			&:hover {
				.customer__agency,
				.customer__referent {
					color: $white;
				}

				.card__header-link {
					color: $white;
				}


				&:before {
					transform: scaleY(1);
					transform-origin: center top;
				}
			}
		}
	}

	@media (min-width: 1300px) {
		.card {
			&__header {
				.customer-search {
					width: 90%;
				}
			}
		}
	}
</style>
